import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import classnames from 'classnames'
import LazyLoad from 'react-lazyload'
import {useTranslation} from '../../i18n'
/**
 * @param images 默认取第一张
 */
const getImgPath = (images: any[]) => {
  if (images === void 0 || images.length === 0) {
    return ''
  }
  if (images[0].thumbnail !== void 0 && images[0].thumbnail.url !== void 0) {
    return images[0].thumbnail.url + '?x-oss-process=image/resize,l_500'
  } else if (images[0].full !== void 0 && images[0].full.url !== void 0) {
    return images[0].full.url + '?x-oss-process=image/resize,l_500'
  }
  return ''
}

export interface IImageModel {
  full?: any
  thumbnail?: any
}

export interface IProductModel {
  colors: any[]
  displayBrand: string
  brand: string
  originalPriceTag: string
  priceTagCN: string
  priceTag: string
  images: IImageModel[],
  officialURL?: string
}

export interface IRankProdutModel {
  product: IProductModel | any
  origin: string
  merchantName: string
  favoritedCount: number
  activityOffs: string[]
}

export interface IProductProps {
  productInfo: IRankProdutModel | any
  className?: string
  clickTo?: (type, path1, path2, componentId, officialURL?: string) => void
  index: number
  pid?: string
}
const Product2: React.FC<IProductProps> = (props: IProductProps) => {
  const mounted: any = useRef()
  const { t } = useTranslation()
  const { productInfo, className, clickTo, index, pid } = props
  const { product, off, activityOffs } = productInfo
  const classes = classnames('lego_rankProduct', className)
  const productName =
    (product.displayBrand
      ? `${product.displayBrand} | `
      : `${product.brand} | `) + (product.nameCN || product.name)
  return (
    <div
      ref={mounted}
      className={classes}
      onClick={() => clickTo('product', product.id, '', pid, product.officialURL)}
      data-productid={product.id}
      data-pid={pid}
      data-id={product.id}
      data-index={index}
    >
      <div className="rankProduct_imgBox">
        <LazyLoad
          classNamePrefix="product2_imgBox_img"
          overflow={true}
          height={50}
        >
          <img src={getImgPath(product.images)} />
        </LazyLoad>
        {product.colors.length > 1 ? (
          <div className="rankProduct_imgBox_colors">
            {product.colors.length}色可选
          </div>
        ) : (
          <div />
        )}
        {product.inventoryStatus !== 'AVAILABLE' && (
          <div className="selloutContent">{ t('SOLD_OUT') }</div>
        )}
      </div>
      <div className="rankProduct_textBox">
        <div className="rankProduct_textBox_title">{productName}</div>
        <div className="rankProduct_priceTagSection">
          <span
            className={`rankProduct_priceTagCN ${
              product.originalPriceTag ? 'blueColor' : ''
            }`}
          >
            {product.priceTagCN}
          </span>
        </div>
        <div className="rankProduct_priceTagCNSection"></div>
        {(off || activityOffs?.length > 0) && (
          <div className="rankProduct_promos">
            {off && <div className="promoMsg_text off">{off}</div>}
            {activityOffs &&
              activityOffs.map((off, index) => {
                return (
                  <div className="promoMsg_text" key={`off${index}`}>
                    {off}
                  </div>
                )
              })}
          </div>
        )}
      </div>
    </div>
  )
}
export default Product2
